/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How many ERSes are billable based on defined billing tier.
 */
export interface ErsPriceDTO { 
    /**
     * Billing price category. Value \'0\' means standard price, value greater than 0 means increased price.
     */
    billingTier?: number;
    /**
     * Number of ERSes
     */
    total?: number;
}

export class ClsErsPriceDTO { 
    /**
     * Billing price category. Value \'0\' means standard price, value greater than 0 means increased price.
     */
    billingTier?: number = undefined;
    /**
     * Number of ERSes
     */
    total?: number = undefined;
}

